<template>
    <div>
        <div v-if="!selectedClient">
            <div v-if="selectedQuote">
                <InvoicePageHeader :selectedInvoice="selectedQuote"></InvoicePageHeader>
            </div>

            <div v-else-if="getAppMode === 'autoservice'">
                <AutoServiceDetailHeader :selectedService="selectedInvoice"></AutoServiceDetailHeader>
            </div>

            <div v-else-if="getAppMode === 'legal'">
                <CaseDetailHeader :selectedCase="selectedInvoice"></CaseDetailHeader>
            </div>

            <div v-else-if="getAppMode === 'privatePractice' || getAppMode === 'social'">
                <PracticeDetailHeader :selectedFile="selectedInvoice"></PracticeDetailHeader>
            </div>

            <div v-else-if="getAppMode === 'projects' || getAppMode === 'events'">
                <ProjectsDetailHeader :selectedProject="selectedInvoice"></ProjectsDetailHeader>
            </div>

            <div v-else>
                <InvoicePageHeader :selectedInvoice="selectedInvoice"></InvoicePageHeader>
            </div>
            
        </div>

        <div v-if="!selectedInvoice && !selectedClient && !selectedQuote">
            <v-card class="mt-4 pa-6 text-center elevation-4">
                <WelcomeNotice
                    :description1="`Select from <strong>Add or Manage ${getFileLabel}s</strong> to capture new ${getFileLabel}s or manage existing ones.`"
                    :description2="`Select from <strong>${getClientLabel}s Accounts</strong> to add or manage existing ${getClientLabel}s, and to view or mark invoices paid.`"
                ></WelcomeNotice>
            </v-card>
        </div>

        
        <div v-if="selectedQuote">
            <Quotations :selectedQuote="selectedQuote"></Quotations>
        </div>

        <div v-if="selectedClient">
            <ClientManager :selectedClientProp="selectedClient" ></ClientManager>
        </div>
    </div>
</template>

<script>
import companiesJs from "@/plugins/companies"
import AutoServiceDetailHeader from "@/modules/AutoServices/AutoServiceDetailHeader.vue"
import CaseDetailHeader from "@/modules/CaseManager/CaseDetailHeader.vue"
import ClientManager from "@/modules/Clients/ClientManager.vue"
import InvoicePageHeader from "@/modules/InvoicesAndQuotes/InvoicePageHeader.vue"
import PracticeDetailHeader from "@/modules/HealthAndSocialWork/PracticeDetailHeader.vue"
import ProjectsDetailHeader from "@/modules/ProjectsIndustry/ProjectsDetailHeader.vue"
import Quotations from "@/modules/InvoicesAndQuotes/Quotations.vue";
import WelcomeNotice from "@/components/General/WelcomeNotice.vue"

export default {
    props:{
        selectedClient:{
            type: Object,
            default:null
        },
        selectedInvoice:{
            type: Object,
            default:null
        },
        selectedQuote:{
            type: Object,
            default:null
        },
    },
    components:{
        AutoServiceDetailHeader,
        CaseDetailHeader,
        ClientManager,
        InvoicePageHeader,
        PracticeDetailHeader,
        ProjectsDetailHeader,
        Quotations,
        WelcomeNotice
    },
    computed:{
        getAppMode(){
            return this.$store.getters.getAppMode
        },
        getFileLabel(){
            return this.$store.getters.getFileLabel
        },
        getClientLabel(){
            return this.$store.getters.getClientLabel
        },
        getUserCompany(){
            return this.$store.getters.getUserCompany
        },
    },
    watch:{
      async getUserCompany(){
        await this.initialiseDashboard()
      }
    },
    async mounted(){
        await this.initialiseDashboard()
    },
    methods:{
        async initialiseDashboard(){
            if(!this.getUserCompany){
                await companiesJs.initialiseCompanyAndLogo()
            }
           
        },
    }
   
}
</script>